import React from 'react'
import Content from '../components/Content';
import Featuredwindows from '../components/Featuredwindows';
import EgressProducts from '../components/EgressProducts';
import HeaderEgressWindowproducts from '../components/HeaderEgressWindowproducts';
import BasicLayout from '../components/BasicLayout';


const EgressWindowProducts = () => {
  return (
    <>
    <BasicLayout>
    <HeaderEgressWindowproducts />
    <Content />
    
    <EgressProducts />
    <Content />
    

    
    <Featuredwindows/>
    </BasicLayout>
   
    </>
  )
}

export default EgressWindowProducts